export default __webpack_public_path__ + "494b0112d3cef4417c14b27d431aae08.jpg";